"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "navbar notification-navbar"
  }, [_c("hamburger", {
    staticClass: "hamburger-container",
    attrs: {
      id: "hamburger-container",
      "is-active": _vm.sidebar.opened
    },
    on: {
      toggleClick: _vm.toggleSideBar
    }
  }), _c("breadcrumb", {
    staticClass: "breadcrumb-container",
    attrs: {
      id: "breadcrumb-container"
    }
  }), _c("div", {
    staticClass: "right-menu"
  }, [_vm.device !== "mobile" ? [_c("el-badge", {
    staticClass: "notification",
    attrs: {
      value: _vm.notificationCount
    }
  }, [_c("el-button", {
    attrs: {
      icon: "el-icon-bell",
      type: "primary",
      size: "mini",
      circle: ""
    },
    on: {
      click: _vm.fetchNotificationsData
    }
  })], 1), _c("el-drawer", {
    attrs: {
      title: `Notifications (${_vm.notificationCount})`,
      visible: _vm.showNotificationSideBar,
      direction: "rtl",
      size: "30%"
    },
    on: {
      "update:visible": function ($event) {
        _vm.showNotificationSideBar = $event;
      }
    }
  }, [_vm.loadingNotifications ? _c("el-skeleton", {
    attrs: {
      rows: 6,
      animated: ""
    }
  }) : _vm._e(), _vm.notificationData.length > 0 ? _vm._l(_vm.notificationData, function (notification) {
    return _c("div", {
      key: notification.id,
      class: "notification-item" + (notification.isRead ? "" : " unread")
    }, [_c("div", {
      staticClass: "notification-content",
      on: {
        click: function ($event) {
          return _vm.markNotificationRead(notification);
        }
      }
    }, [_c("strong", {
      staticClass: "notification-title"
    }, [_vm._v(_vm._s(notification.title))]), _c("p", {
      staticClass: "notification-body"
    }, [_vm._v(" " + _vm._s(notification.message) + " ")])]), _c("i", {
      staticClass: "el-icon-arrow-right notification-right-icon"
    })]);
  }) : _c("div", [_c("el-empty", {
    attrs: {
      description: "No notifications found."
    }
  })], 1), _c("router-link", {
    staticClass: "margin-horizontal",
    attrs: {
      to: "/leads-notifications/list"
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "info",
      size: "mini",
      full: ""
    },
    on: {
      click: function ($event) {
        _vm.showNotificationSideBar = false;
      }
    }
  }, [_vm._v(" View All ")])], 1)])], 2), _c("span", {
    staticClass: "right-menu-item"
  }, [_vm._v(" Welcome " + _vm._s(_vm.loggedInUser) + " ")])] : _vm._e(), _c("el-dropdown", {
    staticClass: "avatar-container right-menu-item hover-effect",
    attrs: {
      trigger: "click"
    }
  }, [_c("div", {
    staticClass: "avatar-wrapper"
  }, [_c("img", {
    staticClass: "user-avatar",
    attrs: {
      src: _vm.avatar ? _vm.avatar : "/default-avatar.png"
    },
    on: {
      error: _vm.onAvatarError
    }
  }), _c("i", {
    staticClass: "el-icon-caret-bottom"
  })]), _c("el-dropdown-menu", {
    attrs: {
      slot: "dropdown"
    },
    slot: "dropdown"
  }, [_c("router-link", {
    attrs: {
      to: "/profile/"
    }
  }, [_c("el-dropdown-item", [_vm._v(_vm._s(_vm.$t("navbar.profile")))])], 1), _c("router-link", {
    attrs: {
      to: "/admins/change-password"
    }
  }, [_c("el-dropdown-item", [_vm._v(" " + _vm._s(_vm.$t("navbar.changePassword")) + " ")])], 1), _c("router-link", {
    attrs: {
      to: "/"
    }
  }, [_c("el-dropdown-item", [_vm._v(_vm._s(_vm.$t("navbar.dashboard")))])], 1), _c("el-dropdown-item", {
    attrs: {
      divided: ""
    }
  }, [_c("span", {
    staticStyle: {
      display: "block"
    },
    on: {
      click: _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t("navbar.logOut")))])])], 1)], 1)], 2)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;